import type { Range } from '@tanstack/react-virtual'

/**
 * Native find-in-page can only match text that is actually in the DOM, so
 * while a find bar is open virtualized lists mount every row — accepting the
 * render cost — and resume windowed rendering when it closes.
 */

/** TanStack Virtual `rangeExtractor` that mounts every row. */
export function mountAllRangeExtractor(range: Range): Array<number> {
  return Array.from({ length: range.count }, (_, index) => index)
}

/** react-virtuoso `increaseViewportBy` taller than any real list, so every row mounts. */
export const MOUNT_ALL_VIEWPORT_BY = { top: 10_000_000, bottom: 10_000_000 }
